// eslint-disable-next-line import/prefer-default-export
export enum PRODUCTS {
	HIGHLIGHTS_PLUS_SUBSCRIPTION = 'Highlights Plus',
}
